export function priceConverter(priceInput, exchangeRate, exchangeRateMode, convertMode, separator = '', locale = 'bg', onlyLocalePrice = false) {

    const parsePriceString = (priceString) => {
        if (typeof priceString === 'number') return priceString;

        if (typeof priceString === 'string')
            return Number(
                priceString
                    .replace(/\s/g, '')       // remove spaces (including non-breaking)
                    .replace('лв.', '')       // remove BGN currency
                    .replace('€', '')         // remove Euro symbol
                    .replace(',', '.')        // replace comma with dot for decimals
            ) || 0;
    };

    const formatPrice = (price, currency, locale) => {
        if (price < 0) {
            return 0;
        }
        let formatedPrice = new Intl.NumberFormat('bg', {
            style: 'currency',
            currency: currency
        }).format(price);

        formatedPrice = formatedPrice.replace(',', '.');
        if (price >= 1000 && locale === 'en') {
         //   formatedPrice = formatedPrice.replace('.', ' ');
        }

        return formatedPrice;
    }

    const eurRate = parseFloat(exchangeRate || '1.95583');
    const mode = parseInt(exchangeRateMode || '2');
    const convertFromEur = parseInt(convertMode || '0');
    const rawPrice = parsePriceString(priceInput);

    if (locale != 'bg') {
        return new Intl.NumberFormat('bg', {
            style: 'currency',
            currency: 'EUR',
        }).format(rawPrice).replace(',', '.');
    }

    if(locale === 'bg' && onlyLocalePrice){
        return formatPrice(rawPrice, 'EUR', 'bg');
    }

    let priceBGN, priceEUR;

    if (convertFromEur === 1) {
        priceEUR = formatPrice(rawPrice, 'EUR', 'en');
        priceBGN = formatPrice(rawPrice * eurRate, 'BGN', 'bg');
    } else {
        priceBGN = formatPrice(rawPrice, 'BGN', 'bg');
        priceEUR = formatPrice(rawPrice / eurRate, 'EUR', 'en');
    }

    if (mode === 0) {
        return priceBGN;
    } else if (mode === 1) {
        return `${priceBGN} ${separator} ${priceEUR}`;
    } else if (mode === 2) {
        return priceEUR;
    }
    return priceBGN;
}
